// extracted by mini-css-extract-plugin
module.exports = {"logoTitle":"LogoTitle_logoTitle___67AY","title":"LogoTitle_title__1Leoi","logo":"LogoTitle_logo__rDYnl"};